import { Component, computed, input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { computePayWeekRange, validateDateRange } from './date-range.utils';
import { MtrFormFieldModule } from '@mortar/angular/components/atomic/form-field';
import { MteFormsModule } from '@mortar/angular/elements/core';
import { MtrInputModule } from '@mortar/angular/components/atomic/input';
import { MteStackWrapper } from '@mortar/angular/elements/atomic/stack';
import { MteCopyButtonModule } from '@mortar/angular/elements/atomic/copy-button';

@Component({
  selector: 'date-within-week-end-date',
  standalone: true,
  template: `
    <mte-stack row>
      <mtr-form-field>
        <input
          #inputElement
          mtr-input
          [id]="id()"
          [formControl]="inputFormControl()"
          type="date"
          [min]="minDate()"
          [max]="maxDate()"
          (change)="handleChange()"
          (paste)="handlePaste($event)" />
      </mtr-form-field>

      <mte-copy-button label="Copy" [value]="copyValue()" successLabel="Copied!" errorLabel="Copy failed" />
    </mte-stack>
  `,
  imports: [MtrFormFieldModule, MteFormsModule, MtrInputModule, MteStackWrapper, MteCopyButtonModule],
})
export class DateWithinWeekEndDateComponent implements OnInit {
  id = input.required<string>();
  inputFormControl = input.required<FormControl<string | null>>();
  weekEndDate = input<string>();
  range = computed(() => computePayWeekRange(this.weekEndDate()));
  minDateTimeOverride = input<string>();
  maxDateTimeOverride = input<string>();
  maxDate = computed(() => {
    const override = this.maxDateTimeOverride();
    return override ? override.substring(0, 10) : this.range().maxDate;
  });
  minDate = computed(() => {
    const override = this.minDateTimeOverride();
    return override ? override.substring(0, 10) : this.range().minDate;
  });

  ngOnInit() {
    this.inputFormControl().addValidators((control) => {
      const raw = control.value;
      if (!raw) return null;
      return validateDateRange({
        raw,
        min: this.minDate(),
        max: this.maxDate(),
        mode: 'date',
      });
    });
  }

  handleChange() {
    this.inputFormControl().markAsTouched();
    this.inputFormControl().updateValueAndValidity();
  }

  copyValue(): string {
    return this.inputFormControl().value ?? '';
  }

  handlePaste(event: ClipboardEvent) {
    const text = event.clipboardData?.getData('text')?.trim();
    if (!text) return;
    event.preventDefault();
    const date = text.substring(0, 10);
    this.inputFormControl().setValue(date);
    this.handleChange();
  }
}
